import { z } from "zod/v4";

export const metadataSchema = z.object({
  id: z.number(),
  model_type: z.string(),
  model_id: z.coerce.string(),
  key: z.string(),
  value: z.string(),
  content: z.unknown().nullable(),
  lendflow_only: z.boolean(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
});

export const metadataPayloadSchema = z.object({
  model_type: z.string(),
  model_id: z.number(),
  key: z.string(),
  value: z.string(),
});

export type Metadata = z.infer<typeof metadataSchema>;
export type MetadataPayload = z.infer<typeof metadataPayloadSchema>;
export type MetadataInput = Pick<MetadataPayload, "key" | "value">;
